
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"69","height":"69","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M52.943 17.721L44.028 8.81a5.1 5.1 0 00-3.602-1.498H18.741a5.117 5.117 0 00-5.1 5.11v44.191a5.1 5.1 0 005.1 5.099h30.6a5.1 5.1 0 005.1-5.099V21.333c0-1.349-.542-2.655-1.498-3.611zm-4.017 3.198h-8.085v-8.084l8.085 8.084zM18.741 56.612V12.421h17v11.047a2.544 2.544 0 002.55 2.55h11.05v30.594h-30.6z","fill":"#282E3E"}}),_c('path',{attrs:{"d":"M33.048 31.364l-7.969 7.909c-.837.832-.248 2.26.932 2.26h5.386v6.612c0 .731.592 1.323 1.323 1.323h2.644c.73 0 1.323-.592 1.323-1.323v-6.611h5.386c1.18 0 1.769-1.429.93-2.261l-7.968-7.91a1.41 1.41 0 00-1.987 0z","fill":"#282E3E"}})])
          )
        }
      }
    